import React, { useState, useEffect } from 'react';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, updateDoc, doc, getDocs } from 'firebase/firestore';
import { storage, db } from '../../../firebase';

const AddPlat = () => {
    const [image, setImage] = useState(null);
    const [nom, setNom] = useState('');
    const [description, setDescription] = useState('');
    const [prix, setPrix] = useState('');
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [disponible, setDisponible] = useState(false);
    const [vegetarienne, setVegetarienne] = useState(false);
    const [prixType, setPrixType] = useState('fixe'); // 'fixe' ou 'variable'
    const [sizes, setSizes] = useState([{ taille: '', prix: '' }]); // Pour les prix variables
    const [addons, setAddons] = useState([]); // Modules complémentaires disponibles
    const [selectedAddon, setSelectedAddon] = useState(''); // Module sélectionné
    const [selectedAddons, setSelectedAddons] = useState([]); // Modules complémentaires sélectionnés
    const [selectedModules, setSelectedModules] = useState([]); // Modules sélectionnés pour un addon

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const categoriesCollection = collection(db, 'categorie');
                const categoriesSnapshot = await getDocs(categoriesCollection);
                const categoriesList = categoriesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setCategories(categoriesList);
            } catch (error) {
                console.error("Error fetching categories: ", error);
            }
        };

        const fetchAddons = async () => {
            try {
                const addonsCollection = collection(db, 'addons');
                const addonsSnapshot = await getDocs(addonsCollection);
                const addonsList = addonsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setAddons(addonsList);
            } catch (error) {
                console.error("Error fetching addons: ", error);
            }
        };

        fetchCategories();
        fetchAddons();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
            let imageUrl = '';
            if (image) {
                // Si une image est sélectionnée, téléchargez-la et obtenez l'URL
                const imageRef = ref(storage, `images/${image.name}`);
                const snapshot = await uploadBytes(imageRef, image);
                imageUrl = await getDownloadURL(snapshot.ref);
            }
    
            // Ajouter le plat dans Firestore
            const docRef = await addDoc(collection(db, 'food-items'), {
                image: imageUrl || '',  // Laisser vide si aucune image
                nom,
                description,
                prix: prixType === 'fixe' ? parseFloat(prix) : null,  // Utiliser prix fixe si applicable
                categorie: selectedCategory,
                disponible,
                vegetarienne,
                prixType,
                sizes: prixType === 'variable' ? sizes.map(size => ({
                    taille: size.taille,
                    prix: parseFloat(size.prix.replace(',', '.')).toFixed(2) // Convertir prix en nombre
                })) : [], // Ajouter les tailles seulement si prix variable
                addons: selectedAddons // Ajouter les modules complémentaires sélectionnés
            });
    
            // Récupérer l'ID généré et l'ajouter au document
            const generatedId = docRef.id;
            await updateDoc(doc(db, 'food-items', generatedId), {
                id: generatedId
            });
    
            console.log("Document ajouté avec ID: ", generatedId);
    
            // Réinitialiser les champs du formulaire après ajout
            setImage(null);
            setNom('');
            setDescription('');
            setPrix('');
            setSelectedCategory('');
            setDisponible(false);
            setVegetarienne(false);
            setPrixType('fixe');
            setSizes([{ taille: '', prix: '' }]);
            setSelectedAddon('');
            setSelectedAddons([]);
            setSelectedModules([]);
            alert("Plat ajouté avec succès !");
        } catch (error) {
            console.error("Erreur lors de l'ajout du plat : ", error);
            alert("Erreur lors de l'ajout du plat.");
        }
    };
    

    const handleAddSize = () => {
        setSizes([...sizes, { taille: '', prix: '' }]);
    };

    const handleSizeChange = (index, e) => {
        const { name, value } = e.target;
        const updatedSizes = [...sizes];
        if (name === 'prix') {
            // Remplacer la virgule par un point et convertir en nombre
            const formattedValue = value.replace(',', '.');
            updatedSizes[index][name] = formattedValue;
        } else {
            updatedSizes[index][name] = value;
        }
        setSizes(updatedSizes);
    };

    const handleRemoveSize = (index) => {
        setSizes(sizes.filter((_, i) => i !== index));
    };

    const handleAddonChange = (e) => {
        setSelectedAddon(e.target.value);
        setSelectedModules([]); // Réinitialiser les modules sélectionnés
    };

    const handleAddAddon = () => {
        if (selectedAddon && !selectedAddons.find(addon => addon.id === selectedAddon)) {
            const addon = addons.find(a => a.id === selectedAddon);
            setSelectedAddons([...selectedAddons, { ...addon }]);
            setSelectedAddon('');
            setSelectedModules([]);
           
        } else {
            alert("Ce module est déjà sélectionné.");
        }
    };

    const handleModuleCheckboxChange = (module) => {
        const alreadySelected = selectedModules.some(m => m.nom === module.nom);
        if (alreadySelected) {
            setSelectedModules(selectedModules.filter(m => m.nom !== module.nom));
        } else {
            setSelectedModules([...selectedModules, { ...module, prix: module.prix }]);
        }
       
    };


   

    return (
        <div id="content-wrapper" className="d-flex flex-column sp-40">
            <div id="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <h6 className="m-0 font-weight-bold text-primary">Ajouter un plat</h6>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit} className="row g-3 needs-validation align-items-center " noValidate>
                                <div className="col-md-6">
                                    <label className="form-label">Image:</label>
                                    <input className="form-control" type="file" onChange={(e) => setImage(e.target.files[0])} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Nom:</label>
                                    <input className="form-control" type="text" value={nom} onChange={(e) => setNom(e.target.value)} required />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Description:</label>
                                    <textarea
                                        className="form-control"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        rows="4" 
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Prix:</label>
                                    <input className="form-control" type="number" value={prix} onChange={(e) => setPrix(e.target.value)} disabled={prixType === 'variable'} required />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Type de prix:</label>
                                    <select className="form-control" value={prixType} onChange={(e) => setPrixType(e.target.value)} required>
                                        <option value="fixe">Prix fixe</option>
                                        <option value="variable">Prix variable</option>
                                    </select>
                                </div>
                                {prixType === 'variable' && (
                                    <>
                                        <div className="col-md-6">
                                            <label className="form-label">Tailles et prix:</label>
                                            {sizes.map((size, index) => (
                                                <div key={index} className="d-flex mb-2">
                                                    <input
                                                        className="form-control me-2"
                                                        type="text"
                                                        name="taille"
                                                        placeholder="Taille"
                                                        value={size.taille}
                                                        onChange={(e) => handleSizeChange(index, e)}
                                                        required
                                                    />
                                                    <input
                                                        className="form-control me-2"
                                                        type="number"
                                                        name="prix"
                                                        placeholder="Prix"
                                                        value={size.prix || ''}
                                                        onChange={(e) => handleSizeChange(index, e)}
                                                        required
                                                    />
                                                    <button type="button" className="btn btn-danger" onClick={() => handleRemoveSize(index)}>Supprimer</button>
                                                </div>
                                            ))}
                                            <button type="button" className="btn btn-primary" onClick={handleAddSize}>Ajouter une taille</button>
                                        </div>
                                    </>
                                )}
                                <div className="col-md-6">
                                    <label className="form-label">Catégorie:</label>
                                    <select className="form-control" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} required>
                                        <option value="">Sélectionner une catégorie</option>
                                        {categories.map(cat => (
                                            <option key={cat.id} value={cat.id}>{cat.nom}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 ">
                                    <label className="form-label mr-4">Disponible:</label>
                                    <input type="checkbox" checked={disponible} onChange={() => setDisponible(!disponible)} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label mr-4">Végétarienne:</label>
                                    <input type="checkbox" checked={vegetarienne} onChange={() => setVegetarienne(!vegetarienne)} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Ajouter un module complémentaire:</label>
                                    <div className='d-flex align-items-center'>
                                    <select className="form-control mr-3" value={selectedAddon} onChange={handleAddonChange}>
                                        <option value="">Sélectionner un module</option>
                                        {addons.map(addon => (
                                            <option key={addon.id} value={addon.id}>{addon.nom}</option>
                                        ))}
                                    </select>
                                    <button type="button" className="btn btn-primary mt-2" onClick={handleAddAddon}>Ajouter</button>
                                    </div>
                                    
                                </div>
                                {selectedAddons.length > 0 && (
                                    <div className="col-md-12">
                                        <label className="form-label">Modules complémentaires sélectionnés:</label>
                                        <ul>
                                            {selectedAddons.map((addon, index) => (
                                                <li key={index}>
                                                    <strong className='org-clr mb-3'>{addon.nom}</strong>
                                                    <ul>
                                                        {addon.modules.map((module, modIndex) => (
                                                            <li key={modIndex}>
                                                                <input
                                                                    type="checkbox"
                                                                    className="mr-3"
                                                                    checked={selectedModules.some(m => m.nom === module.nom)}
                                                                    onChange={() => handleModuleCheckboxChange(module)}
                                                                />
                                                                {module.nom} - {module.prix}€ 
                                                             
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                <div className="col-md-12">
                                    <button type="submit" className="btn btn-primary">Ajouter le plat</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddPlat;
